<template>
  <div>
      <resource-form v-if="form" :model="form.model" :schema="form.schema" :triggers="form.triggers" @submit="handle_submit">
      </resource-form>
      <button class="btn" @click="$emit('cancel')">
        Annuler
      </button>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import ResourceForm from "components/Forms/ResourceForm"
export default {
  components:{
    ResourceForm
  },
  props:["form"],
  computed:{
    ...mapGetters("crm", ["is_fetching","page_of_leads","is_any_errors","errors"]),
  },
  data() {
    return {
      debounced_error_clean:null
    }
  },
  methods:{
    ...mapActions("crm", ["add_contact_to_lead","set_fetching_state","fetch_all_contacts","reset_errors","fetch_a_lead"]),
    handle_submit(event)
    {
      var lead_id = this.$route.params.id
      this.set_fetching_state(true)
      this.add_contact_to_lead({lead_id:lead_id, params:event})
          .then(() => this.fetch_a_lead(lead_id))
          .then(() => this.set_fetching_state(false))
          .then(() => {
            if (!this.is_any_errors) {
              this.$emit('cancel')
            }
          })
    }
  },
  mounted () {
    this.debounced_error_clean = _.debounce(this.reset_errors, 3500)
  },
  watch : {
    errors : function () {
      this.debounced_error_clean()
    },
  }
}
</script>



// WEBPACK FOOTER //
// client/components/CRM/LeadItemAddition.vue